module.exports = __webpack_public_path__ + "media/images/icon__close--rb-white@3x-daf9b05a0b2df08b1243a6820922dfbb.png";